import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';
import { Org } from '@/types';

export const updateOrg = async (updates: Partial<Org>) => {
  const currentOrg = useOrgStore.getState().currentOrg;

  const { orgid, ...bodyWithoutOrgId } = {
    ...currentOrg,
    ...updates,
  };

  const response = await apiRequest({
    url: `/organizations/${orgid}`,
    method: 'PUT',
    target: 'platform',
    body: bodyWithoutOrgId,
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to update organization' };
  }

  return response;
};
